/** Mirrors finance ServiceUnit. */
export const SERVICE_UNITS = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'fixed', label: 'Fixed price' },
  { value: 'milestone', label: 'Per milestone' },
  { value: 'retainer', label: 'Retainer' },
] as const;

export type ServiceUnit = (typeof SERVICE_UNITS)[number]['value'];

export const serviceUnitLabel = (s: string): string =>
  SERVICE_UNITS.find((x) => x.value === s)?.label ?? s;
